import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeaturedServicesPanel = ({ services = [] }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Featured Services</h3>
        <Link to="/product-catalog">
          <Button variant="ghost" size="sm" iconName="ArrowRight">
            View All
          </Button>
        </Link>
      </div>
      <div className="space-y-4">
        {services?.map((service) => (
          <div key={service?.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-muted/50 transition-smooth">
            <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
              <Image 
                src={service?.image} 
                alt={service?.title}
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold text-foreground mb-1 line-clamp-1">
                {service?.title}
              </h4>
              <p className="text-xs text-muted-foreground mb-2 line-clamp-2">
                {service?.description}
              </p>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <span className="text-xs text-muted-foreground bg-muted px-2 py-1 rounded-full">
                    {service?.category}
                  </span>
                  {service?.isPopular && (
                    <span className="text-xs text-accent bg-accent/10 px-2 py-1 rounded-full">
                      Popular
                    </span>
                  )}
                </div>
                
                <div className="flex items-center space-x-1">
                  <Link to={`/service-details?id=${service?.id}`}>
                    <Button variant="ghost" size="sm" iconName="Info">
                      Details
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {services?.length === 0 && (
        <div className="text-center py-8">
          <Icon name="Package" size={32} className="mx-auto text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground">No featured services available</p>
        </div>
      )}
    </div>
  );
};

export default FeaturedServicesPanel;